import { render } from "./Footer.vue?vue&type=template&id=436d7cbb&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=436d7cbb&lang=scss&scoped=true"

import exportComponent from "/lendr-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-436d7cbb"]])

export default __exports__